import { Yup, TRANSLATION} from '@/imports-files/components/model/select-job-modal';
export const CONSTANTS = {
                            formInitialValues: {
                                                    select_job:'',
                                                    details: '', 
                                                    stages: '', 
                                                    automations: '', 
                                                    scorecards: '', 
                                                    sharing: ''
                                               }
                           }
export const SELECT_JOB_VALIDATION = (t) =>  Yup.object().shape({
                                   select_job: Yup.string().required(t('errors:required')).nullable()
                               })
